module.exports = __webpack_public_path__ + "img/index-ydn.b0563f90.png";